<template>
  <el-container v-if="!localReg" class="bg-gradient">

    <vue-particles
    color="#66B1FF"
    :particleOpacity="0.7"
    :particlesNumber="108"
    :particleSize="5"
    linesColor="#909399"
    :lineOpacity="0.528" />


    <el-aside v-if="isDesktop" style="background-color: #545c6480;">

    <el-menu
       background-color="#2f3e5785"
       text-color="#fff"
       active-text-color="#ffd04b"
       default-active="1-1">

      <el-submenu index="1">
        <template #title>
          <i class="fa fa-list"></i>
          <span>Features</span>
        </template>

        <el-menu-item-group title="Any Organisation:">
          <el-menu-item index="0-1"><i class="fa fa-star" />&nbsp;Tower Companies, <i class="fa fa-users" />&nbsp;Telcos</el-menu-item>
          <el-menu-item index="0-2"><i class="fa fa-wifi" />&nbsp;Backhaul Providers</el-menu-item>
          <el-menu-item index="0-3"><i class="fa fa-tools" />&nbsp;Contractors, <i class="fa fa-store-alt" />&nbsp;Landlords</el-menu-item>
          <el-menu-item index="0-4"><i class="fa fa-broadcast-tower" />&nbsp;Tower Suppliers</el-menu-item>
          <el-menu-item index="0-5"> <i class="fa fa-clipboard" />&nbsp;Authorities, <i class="fa fa-plug" />&nbsp;Utilities</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Projects:">
          <el-menu-item index="1-1"><i class="fa fa-share-alt" />&nbsp;Request to Share</el-menu-item>
          <el-menu-item index="1-2"><i class="fa fa-wrench" />&nbsp;Request to Upgrade</el-menu-item>
          <el-menu-item index="1-3"><i class="fa fa-wifi" />&nbsp;Request to Backhaul</el-menu-item>
          <el-menu-item index="1-4"><i class="fa fa-broadcast-tower" />&nbsp;View All Your Sites</el-menu-item>
          <el-menu-item index="1-5"><i class="fa fa-tools" />&nbsp;Installed Equipment</el-menu-item>
        </el-menu-item-group>

        <el-menu-item-group title="Service:">
          <el-menu-item index="2-4"><i class="fa fa-headset" />&nbsp;Instant Tickets</el-menu-item>
          <el-menu-item index="2-5"><i class="fa fa-list" />&nbsp;Custom Workflows</el-menu-item>
        </el-menu-item-group>

      </el-submenu>

      <el-menu-item index="2">
        <i class="fa fa-th-large"></i>
        <span>Easy, Mobile Friendly</span>
      </el-menu-item>
      <el-menu-item index="4">
        <i class="fa fa-user-cog"></i>
        <span>Consistent, Accurate Data</span>
      </el-menu-item>
    </el-menu>

  </el-aside>

  <el-main>

    <div>
      <el-row>

        <el-col v-if="isDesktop" :xs="0" :sm="24" :md="24" :lg="8">
            <el-col  v-for="(l, i) in telcoLogos" :key="i" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
              <img class="logo" :src="l.src" :alt="l.alt" />
            </el-col>
        </el-col>

        <el-col style="padding-bottom: 2.85rem;" class="inner-box" :xs="24" :sm="24" :md="24" :lg="8" align="center">

          <center><img v-if="clientLogo" style="height: 2.85rem; padding: 0.8em;" :src="clientLogo" :alt="clientName"></center>

          <div v-if="!isMaint && !isUnpaid">

            <div
              v-if="logoutReason === 'session-expired'"
              class="session-expired-msg"
              role="status">
              <i class="fa fa-exclamation-circle" />&nbsp;Your session has expired. Please sign in again.
            </div>

            <div
              v-if="logoutReason === 'api-access-denied'"
              class="session-expired-msg"
              role="status">
              <i class="fa fa-ban" />&nbsp;This service can't be reached right now. Please contact your administrator.
            </div>

            <el-form style="padding: 2.85rem;">

                <el-form-item>
                  <el-input style="max-width: 400px; margin:  0 auto;" v-model="login" placeholder="Login" type="text" :disabled="loggingIn" @keyup.native.enter="submitOnEnter" />
                </el-form-item>

                <el-form-item>
<!--                  <el-input v-model="pwd" placeholder="Password" type="password" /> -->
                <password v-model="pwd" toggle @keyup.native.enter="submitOnEnter" />
                </el-form-item>

              <el-row>
                <el-form-item>
                  <el-button type="primary" icon="fa fa-right-to-bracket" :loading="loggingIn" :disabled="loggingIn || (!login) || (!pwd)" @click="doLogin">&nbsp;{{ loggingIn ? 'Signing in...' : 'Login' }}</el-button>
                </el-form-item>

                <el-form-item>
                  <el-button type="danger" icon="fa fa-user-plus" :disabled="loggingIn || !(!login && !pwd)" @click="doRegister">&nbsp;Register</el-button>
                </el-form-item>
              </el-row>

            </el-form>

          </div>

          <div v-else style="margin-bottom: 1rem;">
            <center v-if="isMaint"><h2 class="text-warning">Under Maintenance</h2></center>
            <center v-if="isUnpaid"><h2 class="text-danger">Overdue Payment</h2></center>
          </div>

          <div class="xolas-logo">
            <a href="https://xolas.io" target="_blank"> Powered by&nbsp;<img class="footer-logo" :src="logo" />&nbsp;
            {{appName}}</a>
          </div>

        </el-col>

        <el-col v-if="isDesktop" :xs="0" :sm="24" :md="24" :lg="8">
            <el-col  v-for="(l, i) in otherLogos" :key="i" align="center" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg">
              <img class="logo" :src="l.src" :alt="l.alt" />
            </el-col>
        </el-col>


      </el-row>

    </div>

  </el-main>

</el-container>

<el-container v-else>
  <register :new-system="xolasClient().contactsCount == 0 ? true : false" />
</el-container>

</template>

<script>

import Vue from 'vue'

import {APP_NAME, IS_MAINT, IS_UNPAID, IS_DEV} from '@/components/Data'

import VueParticles from 'vue-particles'
import ProgressiveBackground from 'vue-progressive-image'

import Password from 'vue-password-strength-meter'
import Register from '@/components/login/Register'

Vue.use(ProgressiveBackground)
Vue.use(VueParticles)

export default {

  components: {
    Password,
    Register
  },

  data () {
    return {
      appName: APP_NAME,
      isMaint: IS_MAINT,
      isUnpaid: IS_UNPAID,
      isDev: IS_DEV,
      localReg: false,
      // KAN-39 / acceptance #11: populated on mount when the axios
      // interceptor forced a redirect (e.g. terminal 401 / refresh
      // failure). Read once, then cleared so a later manual /login
      // visit does not re-show the banner.
      logoutReason: null,
      login: null,
      pwd: null,
      loggingIn: false,
      media: {xs: 24, sm: 12, md: 12, lg: 12},
      logo: '../../../static/favicon.png',
      telcoLogos: [
        {src: '../../../static/clients/celcomdigi.png', alt: 'CelcomDigi'},
        {src: '../../../static/clients/maxis.png', alt: 'Maxis'},
        {src: '../../../static/clients/umobile.png', alt: 'U-Mobile'},
        {src: '../../../static/clients/unifi-mobile.png', alt: 'Unifi Mobile'},
        {src: '../../../static/clients/yes.png', alt: 'Yes'},
        {src: '../../../static/clients/sapura-logo-real.svg', alt: 'Sapura'}
      ],
      otherLogos: [
        {src: '../../../static/clients/tm.png', alt: 'Telekom Malaysia'},
        {src: '../../../static/clients/time.png', alt: 'TIME'},
        {src: '../../../static/clients/dnb-logo.svg', alt: 'DNB'},
        {src: '../../../static/clients/dhti.png', alt: 'D\'Harmoni'},
        {src: '../../../static/clients/micth.png', alt: 'MICTH'},
        {src: '../../../static/clients/cttsb-logo.png', alt: 'Common Tower'},
//        {src: '../../../static/clients/teleflow.png', alt: 'Tele-Flow'}
      ]

    }
  },

  computed: {
    // Read reactively from the Vuex store so a late /api/system/client
    // response (fresh session / incognito) still populates the logo —
    // a plain data() snapshot fires before the XHR resolves.
    clientName () {
      return this.xolasClient().name
    },
    clientLogo () {
      return this.xolasClient().logoPath
    }
  },

  methods: {

    doLogin () {
      if (this.loggingIn) {
        return
      }
      this.loggingIn = true
      const result = this.canLogin(this.login, this.pwd)
      if (result && typeof result.then === 'function') {
        result.then(() => { this.loggingIn = false }, () => { this.loggingIn = false })
      } else {
        this.loggingIn = false
      }
    },

    doRegister () {

      if (!this.localReg) {
        this.localReg = true
      }

    },

    submitOnEnter () {
      if (this.loggingIn || !this.login || !this.pwd) return
      this.doLogin()
    }

  },

  created () {
//    console.log('name', this.clientName, 'logo', this.clientLogo)
  },

  mounted () {
    // KAN-39 / acceptance #11: read the logout-reason flag written by
    // src/lib/axiosClient.js on a forced redirect, render the banner,
    // then consume the flag so it does not re-appear on a future visit.
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const reason = window.sessionStorage.getItem('xolas-logout-reason')
        if (reason) {
          this.logoutReason = reason
          window.sessionStorage.removeItem('xolas-logout-reason')
        }
      }
    } catch (e) {
      // ignore
    }
  }
}
</script>

<style scoped>

.logo {
  width: auto;
  height: 1.852rem;
  padding-top: 2rem;
}

.footer-logo {
  width: auto;
  height: 1.396rem;
}

.inner-box {
  padding-top: 1em;
  border-radius: 8.52px;
  background-color: #FFFAFA96;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.0852), 0 6px 20px 0 rgba(0, 0, 0, 0.0852);
}

.xolas-logo {
  width: 280px;
  margin-top: 35px;
  margin-bottom: 24px;
  text-align: center;
  align-items: center;
  font-size: 10pt;
  color: lightgrey;
}

.xolas-logo a:link {
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  color: lightgrey;
}

.session-expired-msg {
  margin: 0.8rem 1.5rem 0;
  padding: 0.6rem 1rem;
  border-radius: 4px;
  background-color: #fef0f0;
  color: #b54141;
  font-size: 13px;
  text-align: center;
}

.bg-gradient {
/*
  background: rgb(214,149,94);
  background: linear-gradient(270deg, rgba(214,149,94,1) 0%, rgba(183,117,60,1) 56%, rgba(75,44,21,1) 100%);
*/
  background: url('/static/login/background.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

#particles-js {
    position: absolute;
    background: inherit;
    left: 9px;
    right: 9px;
    top: 9px;
    bottom: 0;
}

</style>
